import React, { useState, useEffect } from 'react';
import { pick } from 'ramda';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useDynamicReducerSelector } from '../../store';
import * as Types from '../../types';

import style from './DocumentLoadedBanner.scss';

export const DocumentLoadedBanner: React.FC<Types.IDocumentGroupProps> = ({
    documentGroup,
    documentIndex
}) => {
    const { playerTags } = useDynamicReducerSelector(pick(['playerTags']));
    const translate = useComponentTranslations();
    const { playerTag } = documentGroup;
    const [successMessage, setSuccessMessage] = useState<string>('');

    useEffect(() => {
        const tagValue: string = playerTags.find(tag => tag.name === playerTag)?.value || '';
        const [uploadedDocumentType] = tagValue.split(',');
        const documentType = translate(`document.${uploadedDocumentType}`);

        setSuccessMessage(translate('uploadSuccessBanner', [documentType]));
    }, [playerTags, playerTag, setSuccessMessage, translate]);

    if (!successMessage) {
        return null;
    }

    return (
        <div className={style.container}>
            <h2 className={style.title}>
                {translate(`documentIndex.${documentIndex > 2 ? 'other' : documentIndex}`)}
            </h2>
            <div className={style.successMessageContainer}>
                <div className={style.successIcon}></div>
                <div className={style.successMessage}>{successMessage}</div>
            </div>
        </div>
    );
};
